<template>
  <div class="page_box">
    <div class="page_option_box">
      <div class="option_box">
      
      </div>
      <!-- <div class="search_box">
        <el-input
          v-model.trim="requestData.lectureUserName"
          size="mini"
          clearable
          placeholder="请输入会议名称"
        ></el-input>
        <el-button
          size="mini"
          type="primary"
          plain
          icon="el-icon-search"
          @click="searchData"
          >搜索</el-button
        >
      </div> -->
    </div>
    <div class="page_table_box">
      <div class="school_table_box">
        <el-table
          :data="tableData"
          height="100%"
          class="table_box"
          :header-cell-style="{ background: '#E2EEFF', color: '#474859' }"
        >
        <el-table-column
            prop="emergencyPlanId"
            label="预案id"
            align="center"
          ></el-table-column>
          
        
          <el-table-column
            prop="emergencyPlanName"
            label="预案名称"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="emergencyPlanDesc"
            label="预案描述"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="deviceName"
            label="设备状态"
            align="center"
          >
          <template v-slot="scope">
          
            <el-tag v-if="scope.row.emergencyPlanState==1" type="success">进行中</el-tag>
            <el-tag v-if="scope.row.emergencyPlanState==0" type="primary">未开启</el-tag>

          </template>
        </el-table-column>
          <el-table-column label="操作" align="center" width="180">
            <template v-slot="scope">
              <el-link
                type="primary"
                @click="mainClick(scope.row)"
                :underline="false"
                >观看</el-link
              >
       
             
            </template>
            
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination_box">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="requestData.pageNum"
          :page-size="requestData.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <add-or-edit
      :initialData="initialData"
      :drawerShow="drawerShow"
      :drawerType="drawerType"
      @handleClose="handleClose"
      @saveData="saveData"
    ></add-or-edit>
    <!-- <el-dialog   :visible.sync="listShow" :wrapperClosable="false"  :append-to-body="true" title="会议记录" width="70%">
        <List ref="list"></List>
    </el-dialog> -->
  </div>
</template>

<script>
import { Form } from 'element-ui';
//这里可以引入其他文件（比如组件，工具js，第三方插件js，json文件，图片文件等等）
//列如：import <<组件名称>> from '《组件路径》';
import addOrEdit from "./components/planAddOrEdit.vue";
// import List from "./components/list.vue";

export default {
  //import引入的组件需要注入到对象中才能使用
  name: "prelectionRecord",
  components: {
    addOrEdit
  },
  props: {},
  data() {
    //这里存放数据
    return {
      requestData: {
        pageNum: 1,
        pageSize: 20,
        eduId: JSON.parse(sessionStorage.getItem("eduInfo")).eduId,
        regionCode: JSON.parse(sessionStorage.getItem("eduInfo")).regionCode,
        eduBuresuType: JSON.parse(sessionStorage.getItem("eduInfo")).eduBuresuType
      },
      listParams:{
        cloudMeetingId:null,
        pageNum: 1,
        pageSize: 20,
      },
      tableData: [],
      total: 0,
      drawerShow: false,
      drawerType: "add",
      listShow:false,
      initialData: {
        
      }
    };
  },
  //监控data中的数据变化
  watch: {},
  //计算属性，类似于data概念
  computed: {},
  //方法集合
  methods: {
    timeFormate(timeStamp) {
      let year = new Date(timeStamp).getFullYear();
      let month =
        new Date(timeStamp).getMonth() + 1 < 10
          ? "0" + (new Date(timeStamp).getMonth() + 1)
          : new Date(timeStamp).getMonth() + 1;
      let date =
        new Date(timeStamp).getDate() < 10
          ? "0" + new Date(timeStamp).getDate()
          : new Date(timeStamp).getDate();
      let hh =
        new Date(timeStamp).getHours() < 10
          ? "0" + new Date(timeStamp).getHours()
          : new Date(timeStamp).getHours();
      let mm =
        new Date(timeStamp).getMinutes() < 10
          ? "0" + new Date(timeStamp).getMinutes()
          : new Date(timeStamp).getMinutes();
      let ss =
        new Date(timeStamp).getSeconds() < 10
          ? "0" + new Date(timeStamp).getSeconds()
          : new Date(timeStamp).getSeconds();
    
     return    year +"-" + month + "-" +  date +  " " +  " " +   hh +   ":" +   mm +  ":" +   ss;
    },
    searchData() {
      this.requestData.pageNum = 1;
      this.getList();
    },
   
    addClick() {
      this.drawerShow = true;
      this.drawerType = "add";
      
    },
    editClick(row){
      this.initialData=row
      this.drawerShow = true;
      this.drawerType = "edit";
    },
    mainClick(row){
      if(row.emergencyPlanState==0) return this.$message({
          type: "warning",
          message: "当前预案未开启，无法观看"
        });
        this.$router.push({path:'/CloudDrillCenter',query:{data:row.emergencyPlanId} })
      // this.initialData=row
      // this.drawerShow = true;
      // this.drawerType = "info";
    },
    handleCurrentChange(val) {
      this.requestData.pageNum = val;
      this.getList();
    },
    async getList() {
      let req = Object.assign({}, this.requestData);
      let res = await this.$Http.eduResourcePlan(req);
      if (res.code == 200) {
        this.tableData = res.data.list || [];
        this.total = res.data.total || 0;
      } else if (res.code == 101) {
        this.tableData = [];
        this.total = 0;
      } else {
        this.tableData = [];
        this.total = 0;
        this.$message({
          type: "error",
          message: "查询失败"
        });
      }
    },
   
    delClick(info) {
      this.$confirm("确定要删除该预案吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        this.delInfo(info.emergencyPlanId);
      });
    },
    async delInfo(ids) {

      let res = await this.$Http.delResourcePlan({ emergencyPlanId: ids },true);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "删除成功!"
        });
        this.getList();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: "删除失败"
        });
      }
    },
    handleClose() {
      this.drawerShow = false;
    },
    saveData(info) {
      if (this.drawerType == "add") {
        this.addInfo(info);
      } else {
        this.editInfo(info);
      }
    },
    async addInfo(info) {
      let req = Object.assign({}, info);
      let res = await this.$Http.addResourcePlan(req);
      if (res.code == 200) {
        this.drawerShow = false;
        this.$message({
          type: "success",
          message: '操作成功'
        });
        this.getList();
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    async editInfo(info) {
      let req = Object.assign({}, info);
      let res = await this.$Http.editResourcePlan(req);
      if (res.code == 200) {
        this.drawerShow = false;
        this.$message({
          type: "success",
          message: '操作成功'
        });
        this.getList();
      } else {
        this.$message({
          type: "error",
          message: res.data
        });
      }
    },
     // 导出数据
    async exportData() {
      let req = {
        organizationId: this.$store.getters.getUserInfo.schoolId,
        type:3
      };
      this.$Common.exportData(req, "exportLectureRecords", "授课记录", true);
    },
  async showLog(row){
      // listShow
          this.listParams.cloudMeetingId = row.cloudMeetingId
         let res = await this.$Http.CloudMeetingList(this.listParams)
         this.listShow=true
          if (res.code == 200) {
            this.$nextTick(()=>{
              this.$refs.list.init(row.cloudMeetingId)

            })
          } else if (res.code == 101) {
        
          } else {
           
            this.$message({
              type: "error",
              message: "查询失败"
            });
          }
    }
  },
  //生命周期，创建完成（可以访问当前this实例）
  created() {
    
  },
  //生命周期，挂载完成（可以访问dom元素）
  mounted() {
    this.getList();
  },
  beforeCreate() {}, //生命周期-创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之后
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroy() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped></style>
